import { HighSchool } from '../models/common-data';

export class StaticDataUtil {
  static getHiSchoolName(highSchools: HighSchool[], schoolId: string): string {
    for (const highSchool of highSchools) if (highSchool.id.trim() === schoolId) return highSchool.name;
    return '';
  }
}
